import { useSelector } from 'react-redux';
import { BestellungSelectors } from '../../store/Bestellung.store';
import { BestelluebersichtSelectors } from '../../store/Bestelluebersicht.store';
import { ArtikelZulageFilter } from '../types/artikelZulage';

export type ArtikelZulagePartnerContext = {
    warenempfaengerPartnerNummer: string;
    rechnungsempfaengerPartnerNummer: string;
};

export const useArtikelZulagePartnerContext = (): ArtikelZulagePartnerContext => {
    const warenempfaengerPartnerNummerFromBestellung = useSelector(BestellungSelectors.warenempfaengerPartnerNummer);
    const rechnungsempfaengerPartnerNummerFromBestellung = useSelector(BestellungSelectors.rechnungsempfaengerPartnerNummer);
    const currentBestellung = useSelector(BestelluebersichtSelectors.currentBestellung);

    const warenempfaengerPartnerNummer =
        (warenempfaengerPartnerNummerFromBestellung && String(warenempfaengerPartnerNummerFromBestellung).trim() !== ''
            ? warenempfaengerPartnerNummerFromBestellung
            : currentBestellung?.warenempfaenger?.partnerNummer) ?? '';

    const rechnungsempfaengerPartnerNummer =
        (rechnungsempfaengerPartnerNummerFromBestellung && String(rechnungsempfaengerPartnerNummerFromBestellung).trim() !== ''
            ? rechnungsempfaengerPartnerNummerFromBestellung
            : currentBestellung?.rechnungsempfaenger?.partnerNummer) ?? '';

    return { warenempfaengerPartnerNummer, rechnungsempfaengerPartnerNummer };
};

export const createArtikelZulageFilter = (
    artikelgruppeId: string,
    werkId: string | undefined,
    partners: ArtikelZulagePartnerContext
): ArtikelZulageFilter | null => {
    if (!artikelgruppeId || !partners.warenempfaengerPartnerNummer) {
        return null;
    }

    return {
        artikelgruppeId,
        werkId,
        partnerNummer: partners.warenempfaengerPartnerNummer,
        rechnungsempfaengerPartnerNummer: partners.rechnungsempfaengerPartnerNummer || undefined,
    };
};
